/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".p-sortable-column{width:180px;font-weight:550}.ui-table .ui-sortable-column,.ui-table-tbody>tr>td{width:200px}.pheader{color:#004aad;font-size:1.5em}.show_click{cursor:pointer}body,html{font-family:Montserrat,sans-serif!important}.text-center{justify-content:center!important}"];
export { styles as styles };

